<div class="tooltip-row legend-container">
  <div>
    <div class="legend-section">
      <strong>Comparators</strong>
      <div class="tooltip-grid">
        <span>></span> <span>Greater than</span>
        <span>≥</span> <span>Greater than or equal to</span>
        <span>&lt;</span> <span>Less than</span>
        <span>≤</span> <span>Less than or equal to</span>
      </div>
    </div>
    <div class="legend-section">
      <strong>Rarities</strong>
      <div class="tooltip-grid">
        <span class="rarity-circle rarity-normal"></span> <span>Normal</span>
        <span class="rarity-circle rarity-magic"></span> <span>Magic</span>
        <span class="rarity-circle rarity-rare"></span> <span>Rare</span>
        <span class="rarity-circle rarity-unique"></span> <span>Unique</span>
      </div>
    </div>
    <div class="legend-section">
      <strong>Gear Tiers</strong>
      <div class="tooltip-grid">
        <app-gear-tier-icon [tier]="BaseTypeTier.Basic"></app-gear-tier-icon> <span>Basic</span>
        <app-gear-tier-icon [tier]="BaseTypeTier.Advanced"></app-gear-tier-icon> <span>Advanced</span>
        <app-gear-tier-icon [tier]="BaseTypeTier.Expert"></app-gear-tier-icon> <span>Expert</span>
        <app-gear-tier-icon [tier]="BaseTypeTier.Elite"></app-gear-tier-icon> <span>Elite</span>
        <app-gear-tier-icon [tier]="BaseTypeTier.Master"></app-gear-tier-icon> <span>Master</span>
      </div>
    </div>
  </div>
  <div>
    <div class="legend-section">
      <strong>Tiers</strong>
      <div class="tooltip-grid">
        <span class="tier-{{ sTierColor?.toLocaleLowerCase() }}-color">S-Tier</span> <span class="tier-{{ sTierColor?.toLocaleLowerCase() }}-color">{{ sTierColor || 'Visible' }}</span>
        <span class="tier-{{ aTierColor?.toLocaleLowerCase() }}-color">A-Tier</span> <span class="tier-{{ aTierColor?.toLocaleLowerCase() }}-color">{{ aTierColor || 'Visible' }}</span>
        <span class="tier-{{ bTierColor?.toLocaleLowerCase() }}-color">B-Tier</span> <span class="tier-{{ bTierColor?.toLocaleLowerCase() }}-color">{{ bTierColor || 'Visible' }}</span>
        <span class="tier-{{ cTierColor?.toLocaleLowerCase() }}-color">C-Tier</span> <span class="tier-{{ cTierColor?.toLocaleLowerCase() }}-color">{{ cTierColor || 'Visible' }}</span>
        <span class="tier-{{ dTierColor?.toLocaleLowerCase() }}-color">D-Tier</span> <span class="tier-{{ dTierColor?.toLocaleLowerCase() }}-color">{{ dTierColor || 'Visible' }}</span>
        <span class="tier-visible-color">E-Tier</span> <span class="tier-visible-color">Default</span>
        <span class="tier-hidden-color">F-Tier</span> <span class="tier-hidden-color">Hidden</span>
      </div>
    </div>
    @if (minimapIconCurrencyCosmetics && minimapIconCurrencyCosmetics.length > 0) {
      <div class="legend-section">
        <strong>Minimap Icons</strong>
        <div class="tooltip-grid">
          <span>
            @for (icon of minimapIconCurrencyCosmetics; track $index) {
              <app-minimap-icon [cosmeticOptions]="icon"></app-minimap-icon>
            }
          </span>
          <span>Currency</span>
          <span>
            @for (icon of minimapIconItemsCosmetics; track $index) {
              <app-minimap-icon [cosmeticOptions]="icon"></app-minimap-icon>
            }
          </span>
          <span>Items</span>
          <span>
            @for (icon of minimapIconWaystonesCosmetics; track $index) {
              <app-minimap-icon [cosmeticOptions]="icon"></app-minimap-icon>
            }
          </span>
          <span>{{ poe2 ? 'Waystones' : 'Maps' }}</span>
          @if (poe1) {
            <span>
              @for (icon of minimapIconGemCosmetics; track $index) {
                <app-minimap-icon [cosmeticOptions]="icon"></app-minimap-icon>
              }
            </span>
            <span>Gems</span>
          }
          <span>
            @for (icon of minimapIconGoldCosmetics; track $index) {
              <app-minimap-icon [cosmeticOptions]="icon"></app-minimap-icon>
            }
          </span>
          <span>Gold</span>
        </div>
      </div>
    }
  </div>
</div>
<div class="tooltip-row legend-container tooltip-section">
  <div class="legend-section">
    <strong>Terminology</strong>
    <div class="tooltip-grid align-baseline">
      <span>Item</span> <span class="property-value-color">Both Currency and Equipment</span>
      <span>Currency</span> <span class="property-value-color">Anything stackable and typically usable</span>
      <span>Equipment</span> <span class="property-value-color">Any item you can wear: <br />Gear, Jewellery, Flasks {{ poe2 ? 'and Charms' : 'and Tinctures' }}</span>
      <span>Gear</span> <span class="property-value-color">Weapons, Armour and Shields</span>
      <span>Jewellery</span> <span class="property-value-color">Rings, Amulets, Belts, Jewels {{ poe1 ? 'and Talismans' : '' }}</span>
      @if (poe1) {
        <span>Special</span> <span class="property-value-color">Influenced, Fractured,<br />Veiled, containing Memory Strands</span>
      }
      <span>Base Type</span> <span class="property-value-color">The specific type of item.</span>
      <span>Gear Tier</span> <span class="property-value-color">The tier of the Gear Base Type <br />(Basic, Advanced, Expert, Elite, Master).</span>
    </div>
  </div>
</div>
<div class="legend-container tooltip-section">
  <div class="legend-section">
    <strong>Keyboard Shortcuts</strong>
    <div class="tooltip-row">
      <div class="tooltip-grid align-baseline">
        <span class="keys"><span class="key"> F </span><span class="keys-plus">/</span><span class="key"> Q </span></span> <span class="property-value-color">Quick Filters</span>
        <span class="keys"><span class="key"> P </span></span> <span class="property-value-color">Presets</span>
        <span class="keys"><span class="key"> S </span><span class="keys-plus">/</span><span class="key"> O </span></span> <span class="property-value-color">Cosmetics</span>
        <span class="keys"><span class="key"> C </span></span> <span class="property-value-color">Custom Rules</span>
        <span class="keys"><span class="key"> R </span><span class="keys-plus">/</span><span class="key"> V </span></span> <span class="property-value-color">Preview</span>
        <span class="keys"><span class="key"> T </span></span> <span class="property-value-color">Tier Lists</span>
      </div>
      <div class="tooltip-grid align-baseline">
        <span class="keys"><span class="key"> G </span></span> <span class="property-value-color">Gear Tiers</span>
        <span class="keys"><span class="key"> U </span></span> <span class="property-value-color">Uniques</span>
        <span class="keys"><span class="key"> B </span></span> <span class="property-value-color">Chance Bases</span>
        <span class="keys"><span class="key"> J </span></span> <span class="property-value-color">Jewellery</span>
        <span class="keys"><span class="key"> I </span></span> <span class="property-value-color">Items</span>
        <span class="keys"><span class="key"> M </span></span> <span class="property-value-color">Mods</span>
        @if (poe1 && !filter.ruthless) {
          <span class="keys"><span class="key"> D </span></span> <span class="property-value-color">Div Cards</span>
        }
      </div>
    </div>
  </div>
</div>
<div class="tooltip-row legend-container tooltip-section">
  <div class="legend-section">
    <strong>Rule Navigation: </strong> <span class="keys"><span class="key">Ctrl</span></span>-Click a rule's title to view it
    <br />in the Filter Output; and vice-versa.
    <br /><strong>Simulator:</strong> Hover over an item in game, press <span class="keys"><span class="key">Ctrl</span><span class="keys-plus">+</span><span class="key">C</span></span>,
    <br />then <span class="keys"><span class="key">Ctrl</span><span class="keys-plus">+</span><span class="key">V</span></span> anywhere in the tool to see if and how
    <br />it would be displayed, and by which rule(s).
  </div>
</div>
